module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Bold-0291affb999e10df5e176c484b1052be.woff";